import SituacaoOrdemServicoService from "@/services/SituacaoOrdemServicoService";

export const situacaoOrdemServico = {
  namespaced: true,
  state: {
    situacaoOrdemServico: {},
  },
  actions: {
    getSituacaoOrdemServico({ commit }, payload) {
      return SituacaoOrdemServicoService.GetSituacaoOrdemServico(payload).then(
        (situacaoOrdemServico) => {
          return Promise.resolve(situacaoOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postSituacaoOrdemServico({ commit }, payload) {
      return SituacaoOrdemServicoService.PostSituacaoOrdemServico(payload).then(
        (situacaoOrdemServico) => {
          return Promise.resolve(situacaoOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putSituacaoOrdemServico({ commit }, payload) {
      return SituacaoOrdemServicoService.PutSituacaoOrdemServico(payload).then(
        (situacaoOrdemServico) => {
          return Promise.resolve(situacaoOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteSituacaoOrdemServico({ commit }, payload) {
      return SituacaoOrdemServicoService.DeleteSituacaoOrdemServico(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getSituacaoOrdemServicoOData({ commit }, payload) {
      return SituacaoOrdemServicoService.GetSituacaoOrdemServicoOData(
        payload
      ).then(
        (situacaoOrdemServico) => {
          return Promise.resolve(situacaoOrdemServico);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default situacaoOrdemServico;
